import { useNavigate } from "react-router-dom";
import useGlobal from "../../../../store";
import Carcas from "../../../components/containers/carcas";
import DataList from "../../../components/ui/data.list";
import DataListControls from "../../../components/ui/data.list.controls";
import { useGet } from "../../../../scripts/backend/hooks";
import { useEffect, useState } from "react";
import numberSpaces from "../../../../scripts/helpers/numbers.with.spaces";
import cookie from "react-cookies";
import API from "../../../../constants/api";
import axios from "axios";
import DateFieldWithoutTime from "../../../components/ui/data.list/data.list.fields/date.field/without.time";
import ToggleSlider from "../../../components/inputs/toggleslider";
import PhoneGoWhatsApp from "../../../components/ui/data.list/data.list.fields/phone.go.whatsapp";

const BuysForUsers = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { dummy } = globalState;
  const { updateRender } = globalActions;

  const [ isLoading, setLoading ] = useState({});
  const [ result, setResult ] = useState([]);

  async function getData({ orderBy }) {

    try {

      setLoading( true );
      const token = cookie.load('token');

      if ( !token ) { throw('Токен не найден'); }


      const { data } = await axios.post( API.statistic.buys_for_users, { token, orderBy });

      setLoading( false );

      if ( !data?.success ) { throw( data?.error || data?.message || 'Не удалось получить статистику' ); }

      setResult( data.result );
      updateRender();

    } catch ( err ) {

      console.error( 'StatsList getStats error', err );
      setLoading( false );
      setResult([]);
      globalActions.sign.Logout();

    }

  }

  const ORDER_BY_MODES = [
    { id: 'date', name: 'По дате покупки' },
    { id: 'buys', name: 'По кол-ву покупок' },
  ]

  const [ orderBy, setOrderBy ] = useState( ORDER_BY_MODES[ 1 ].id )

  useEffect(() => {
    getData({ orderBy });
  }, [ orderBy ]);

  return (

    <Carcas>

      <ToggleSlider

        list = { ORDER_BY_MODES }
        selected = { orderBy }
        select = { setOrderBy }
        style = {{ maxWidth: '450px' }}

      />


      {/* <DataListControls /> */}

      { isLoading ? <p>Загружаю...</p> :

        <DataList

          source = { result }
          // onRowClick = { openEditForm }
          widths = "60px 250px 140px 100px 150px 150px 100px 130px 200px 150px 60px 190px 190px 1000px 1000px"
          names = {[ "ID", "E-mail", "Телефон", "Покупок", "Крайняя покупка", "Тариф закончится", "Стоимость", "Всего принёс", "utm_campaign", "utm_source", "lang", "utm_firstscreen_width", "utm_firstscreen_height", "utm_firstpage_url", "utm_referrer" ]}
          values = {[ "id", "email", "phone", "buys", "buy_date", "tariff_end_date", "buy_price", "all_buys_price", "utm_campaign", "utm_source", "lang", "utm_firstscreen_width", "utm_firstscreen_height", "utm_firstpage_url", "utm_referrer"  ]}
          containers = {{
            2: PhoneGoWhatsApp,
            4: DateFieldWithoutTime,
            5: DateFieldWithoutTime
          }}

        />

      }

    </Carcas>
    
  );

}

export default BuysForUsers;
